import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  // base64-encoded audio data (data URL format: data:audio/mp3;base64,...)
  data: z.string().min(1),
  fileName: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  audioUrl: string;
};

export async function uploadAudio(input: InputType): Promise<OutputType> {
  const response = await fetch('/_api/music-video/upload-audio', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: superjson.stringify(input),
    credentials: 'include',
  });

  if (!response.ok) {
    const err = superjson.parse<{ error: string }>(await response.text());
    throw new Error(err.error || 'Failed to upload audio');
  }

  return superjson.parse<OutputType>(await response.text());
}
